module.exports = __webpack_public_path__ + "bb4814309066e417c815d2b2fc0ddc8a.svg";